module.exports = __webpack_public_path__ + "img/icon_money.09c588a.svg";